<template>
    <div class="reservation-list-wrapper position-relative">
        <LoadingOverlay :model-value="loading" />
        <div v-if="!reservations.length && !loading">{{ $t('reservations.noReservations') }}</div>
        <v-row v-else>
        <v-col
            v-for="reservation in reservations"
            :key="reservation.uid"
            cols="12"
            lg="6"
        >
            <ReservationCard
                :reservation="reservation"
                :entry-type="entryType"
                :is-entry-owner="isEntryOwner"
                @cancel="$emit('cancel', reservation)"
                @confirm="(payload) => $emit('confirm', reservation, payload)"
                @price-counter-offer="(payload) => $emit('price-counter-offer', reservation, payload)"
                @price-offer="(payload) => $emit('price-offer', reservation, payload)"
                @accept-price-counter-offer="$emit('accept-price-counter-offer', reservation)"
                @decline="$emit('decline', reservation)"
                @confirm-completed="$emit('confirm-completed', reservation)"
                @rated="$emit('rated', reservation)"
                @download-transport-order="$emit('download-transport-order', reservation)"
                @modify-transport-order="$emit('modify-transport-order', reservation)"
                @send-transport-order="$emit('send-transport-order', reservation)"
                @upload-signed-pdf="(file) => $emit('upload-signed-pdf', reservation, file)"
                @upload-cmr="(file) => $emit('upload-cmr', reservation, file)"
                @upload-invoice="(file) => $emit('upload-invoice', reservation, file)"
                @upload-generated-transport-order="(file) => $emit('upload-generated-transport-order', reservation, file)"
                @generate-transport-order="$emit('generate-transport-order', reservation)"
                @confirm-transport-order="$emit('confirm-transport-order', reservation)"
            />
        </v-col>
    </v-row>
    </div>
</template>

<script>
import LoadingOverlay from "@/components/display/LoadingOverlay.vue";
import ReservationCard from "./ReservationCard.vue";

export default {
    name: "ReservationList",
    components: { LoadingOverlay, ReservationCard },
    props: {
        reservations: { type: Array, required: true },
        entryType: { type: String, required: true },
        isEntryOwner: { type: Boolean, required: true },
        loading: { type: Boolean, default: false },
    },
    emits: [
        "cancel", "confirm", "decline", "confirm-completed", "rated",
        "price-counter-offer", "accept-price-counter-offer", "price-offer",
        "download-transport-order", "modify-transport-order", "send-transport-order",
        "upload-signed-pdf", "upload-cmr", "upload-invoice", "upload-generated-transport-order", "generate-transport-order", "confirm-transport-order",
    ],
};
</script>
